/*jshint unused:false*/
import axios from 'axios';
import Vue from 'vue';
import debounce from 'lodash.debounce';
import Autocomplete from '../components/vue/_autocomplete.vue';

const Dropbox = new Vue({
  el: '#content',
  components: { Autocomplete },
  data: function () {
    return {
      q: '',
      suggestions: [],
      googleErrorStatus: '',

      status: '',
      map: '',
      geocoder: '',
      address: '',
      latlngbounds: '',
      addressLatlng: '',
      lastItemInList: null,
      dropboxTypes: '',
      activeDropbox: null,
      dropboxes: [],
      dropboxList: [],
      markers: [],
      dropboxIncrement: 5,
      dropboxCount: 0,
      maxDistance: 100, // in km
      loadMoreClicked: false,
      mapMoved: false,
      distanceFromInput: 0, // in km,
      userLatlng: 0
    }
  },
  computed: {
    remainingDropboxes: function () {
      return this.dropboxes.filter((dropbox) => {
        const marker = this.findMarker(dropbox.id);
        return !this.markers.includes(marker);
      })
    }
  },
  mounted () {
    this.geocoder = new google.maps.Geocoder();

    this.map = new google.maps.Map(this.$refs.map, {
      zoom: 5,
      center: {lat: 56.99884, lng: -100.35938}, // center of Canada
      disableDefaultUI: true,
      zoomControl: true,
      streetViewControl: true
    });

    this.dropboxTypes = {
      '1': {
        label: document.querySelector('[data-map-type="1"] [data-map-type-label]').textContent.trim(),
        icon: {
          url: '/images/pin-bin.png'
        },
        iconActive: {
          url: '/images/pin-bin-active.png'
        }
      },
      '2': {
        label:document.querySelector('[data-map-type="2"] [data-map-type-label]').textContent.trim(),
        icon: {
          url: '/images/pin-pod.png'
        },
        iconActive: {
          url: '/images/pin-pod-active.png'
        }
      },
      '3': {
        label:document.querySelector('[data-map-type="3"] [data-map-type-label]').textContent.trim(),
        icon: {
          url: '/images/pin-ndt.png'
        },
        iconActive: {
          url: '/images/pin-ndt-active.png'
        }
      },
      '4': {
        label: document.querySelector('[data-map-type="4"] [data-map-type-label]').textContent.trim(),
        icon: {
          url: '/images/pin-vv.png'
        },
        iconActive: {
          url: '/images/pin-vv-active.png'
        }
      }
    };

    // Fired when the map becomes idle after panning or zooming.
    google.maps.event.addListener(this.map, 'idle', this.showVisibleMarkers);

    // Fired when the map has finished dragging
    google.maps.event.addListener(this.map, 'dragend', debounce(() => {
      this.mapMoved = true;
      this.distanceFromInput = this.checkDistanceMoved();
    }, 150));

    const searchString = window.location.search.substring(1),
          params = searchString.split("&");

    params.forEach((param) => {
      const value = param.split('=');
      if (value[0] === 'address') {
        this.status = 'BUSY';
        this.q = decodeURI(value[1]);
        this.getLatLng(this.q);
      }
    })
  },
  methods: {
    getUserLocation () {
      this.status = 'BUSY';

      const geoOptions = {
        enableHighAccuracy: true,
        maximumAge: 0
      };

      if (!this.userLatlng) {
        navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError, geoOptions);
      } else {
        this.getAddressFromLatLng(this.userLatlng);
      }
    },
    geoSuccess (pos) {
      const crds = pos.coords;

      this.userLatlng = new google.maps.LatLng(crds.latitude, crds.longitude)

      this.getAddressFromLatLng(this.userLatlng);
    },
    geoError (err) {
      this.status = 'ERR';
      console.warn(`ERROR(${err.code}): ${err.message}`);
    },
    // used for: autocomplete component
    getSuggestions () {
      // clear the results when the text input has changed
      this.status = '';
      this.googleErrorStatus = '';

      if (this.q.length <= 2) {
        // if the value is empty clear results
        this.suggestions = [];
      } else {
        const service = new google.maps.places.AutocompleteService();

        service.getPlacePredictions({
          input: this.q,
          componentRestrictions: { country: 'ca' }
        }, (predictions, status) => {
          if (predictions) {
            this.suggestions = predictions;
          } else {
            // capture the status for the enter event since
            this.googleErrorStatus = status;
          }
        });
      }
    },
    // Check address value from input
    handleUserInput (address) {
      this.status = 'BUSY';

      // empty suggestions array because we don't need it anymore
      this.suggestions = [];

      if (this.googleErrorStatus) {
        // Since we already know the result of this, fake loading so users feel confident the search worked
        setTimeout(() => {
          this.status = 'NOT_FOUND';
        }, 500);
      } else if (!this.q) {
        // if the address input is empty
        this.status = 'NOT_FOUND';
      } else {
        this.address = address;
        this.getLatLng(this.address);
      }
    },
    checkDistanceMoved () {
      if (this.address) {
        return Math.round(google.maps.geometry.spherical.computeDistanceBetween(this.addressLatlng, this.map.getCenter()) / 100) / 10;
      }
    },
    searchNewArea () {
      this.status = 'BUSY';

      const centerLatLng = this.map.getCenter();

      this.getAddressFromLatLng(centerLatLng);
    },
    getLatLng (address) {
      // set address to input address because vmodel doesn't get updated properly with google autocomplete
      this.address = address;
      // Google API call
      this.geocoder.geocode({ 'address': address }, (results, status) => {
        // Reset map state
        this.mapMoved = false;

        if (status == 'OK') {
          // pass off lat/lng to our API...
          this.getDropboxes(results[0].geometry.location);
        } else {
          // there was an error getting the lat/lng
          this.status = 'NOT_FOUND';
        }
      });
    },
    getAddressFromLatLng (latlng) {
      this.geocoder.geocode({'location': latlng}, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            // Find out if the new area is in Canada
            let country;
            
            results[0].address_components.find((comp) => {
              if (comp.types[0] == 'country') {
                country = comp.short_name
              } else if (comp.types.length == 2 && comp.types[0] == 'political') {
                country = comp.short_name
              }
            });

            if (country == 'CA') {
              this.q = results[0].formatted_address;
              this.address = this.q;

              this.getDropboxes(latlng);
            } else {
              this.status = 'NOT_FOUND';  
            }
          } else {
            this.status = 'NOT_FOUND';
          }
        } else {
          this.status = 'NOT_FOUND';
        }
      }); 
    },
    getDropboxes (latlng) {
      this.distanceFromInput = 0;

      // If there are markers already on the map, clear them
      if (this.markers.length) {
        this.dropboxes = [];

        this.markers.forEach((marker) => {
          this.removeMarker(marker);
        })
      }

      // Set variables equal to numbers, since we get back a Google Lat/Lng object
      let lat = latlng.lat(),
          lng = latlng.lng();

      // Set headers for IE caching issue
      const config = {  
        headers: {
          'Cache-Control' : 'no-cache', 
          'If-Modified-Since' : '0'
        } 
      };

      // Call to API to get results
      axios.get(`api/dropboxapi/FindDropBoxes?count=3&radiusKm=${this.maxDistance}&latitude=${lat}&longitude=${lng}`, config)
      .then((res) => {
        console.log(res)
        if (res.data.result.length) {
          // Set results equal to dropboxes array for us to work with
          this.dropboxes = res.data.result;
          // Create map markers
          this.setInitMapBounds(lat, lng);
        } else {
          this.status = 'NOT_FOUND';
        }
      })
      .catch(function (error) {
        console.log(error);
        this.status = 'NOT_FOUND';
      });
    },
    setInitMapBounds (lat, lng) {
      // Prepare Google LatLng bounds for us to set once markers are placed
      this.latlngbounds  = new google.maps.LatLngBounds();
      this.addressLatlng = new google.maps.LatLng(lat,lng);

      var initNumberofBoxes = Math.min(this.dropboxes.length, this.dropboxIncrement);
      for (let i = 0; i < initNumberofBoxes; i++) {
        const latlng = new google.maps.LatLng(this.dropboxes[i].latitude,this.dropboxes[i].longitude);
        this.latlngbounds.extend(latlng);
      }

      // Bind map viewport to the closest ${#} of results matching the list
      this.map.fitBounds(this.latlngbounds);
    },
    showVisibleMarkers () {
      // If there isn't an address entered, don't do any of this
      if (this.address) {
        const bounds = this.map.getBounds();

        // reset the display list
        this.dropboxList = [];

        this.dropboxes.forEach((dropbox) => {
          const latlng = new google.maps.LatLng(dropbox.latitude,dropbox.longitude);
          const marker = this.findMarker(dropbox.id);

          // If the marker is in the bounds and doesn't already exist, add it
          if (bounds.contains(latlng) === true && !marker) {
            this.createMarker(dropbox);

            dropbox.directions = encodeURI(`https://www.google.com/maps/dir/?api=1&origin=${this.q}&destination=${dropbox.addressLine}`);

          // If marker is out of bounds and does exist, remove it
          } else if (bounds.contains(latlng) === false && marker) {
            const newMarkers = this.markers.filter((marker) => {
              return marker.id != dropbox.id;
            });
            
            this.removeMarker(marker, newMarkers);
          } 
        });

        // if there are no visible markers, show no results message
        if (!this.markers.length && this.mapMoved) {
          setTimeout(() => {
            this.status = 'NOT_FOUND';
          }, 500);
        } else {
          setTimeout(() => {
            this.status = 'OK';
          }, 500);

          // push each dropbox into the list in the correct order (by distance, returned from API)
          // there might be a better way to solve this problem...

          // find all the dropboxes that currently exist on the map
          const plottedDropboxes = this.dropboxes.filter((dropbox) => {
            return this.findMarker(dropbox.id);
          })

          // push each of those dropbox markers to be displayed in the list
          plottedDropboxes.forEach((dropbox) => {
            this.dropboxList.push(dropbox);
          });
          
          if (this.loadMoreClicked) {
            Vue.nextTick(() => {
              this.$refs.dropboxCard[this.setFocusIndex].focus();
            })

            this.loadMoreClicked = false;
          }
        }
      }
    },
    createMarker (dropbox) {
      // Generate Google LatlLng object to place the marker
      dropbox.dropboxLatLng = new google.maps.LatLng(dropbox.latitude,dropbox.longitude);

      const marker = new google.maps.Marker({
        position: dropbox.dropboxLatLng,
        icon: this.dropboxTypes[dropbox.type].icon,
        map: this.map,
        id: dropbox.id,
        type: dropbox.type
      });

      marker.addListener('click', () => { 
        this.handleMarkerClick(marker);
      });

      this.latlngbounds.extend(dropbox.dropboxLatLng);
      
      this.markers.push(marker);
    },
    handleListItemClick (id) {
      const marker = this.findMarker(id);
      this.setActiveMarker(marker);
    },
    handleMarkerClick (marker) {
      this.setActiveMarker(marker);
      // show tooltip only on mobile, focus list item on desktop
      if (window.innerWidth < 1024) {
        const dropbox = this.findDropbox(marker.id)

        this.activeDropbox = dropbox;

        this.map.setCenter(marker.getPosition());
      } else {
        const listItem = document.querySelector(`[data-marker-id="${marker.id}"]`);
        listItem.focus();
      }
    },
    handleNotesClick (id, action) {
      const el = document.querySelector(`[data-marker-id="${id}"]`),
            notesBtn = el.querySelector('[data-marker-notes="toggle"]'),
            notes    = el.querySelector('[data-marker-notes="container"]'),
            details  = Array.from(el.querySelectorAll('[data-marker-details]')),
            backBtn  = el.querySelector('[data-marker-notes="back"]');

      if (action === "show") {
        details.forEach((div) => { div.setAttribute('aria-hidden', true) }) 
        notes.setAttribute('aria-hidden', false);
        backBtn.focus();
      } else if (action === "hide") {
        details.forEach((div) => { div.setAttribute('aria-hidden', false) }) 
        notes.setAttribute('aria-hidden', true);
        notesBtn.focus();
      }
    },
    handleLoadMoreClick () {
      this.loadMoreClicked = true;
      var initNumberofBoxes = Math.min(this.dropboxIncrement.length, this.dropboxIncrement);
      for (let i = 0; i < initNumberofBoxes; i++) {
        const latlng = new google.maps.LatLng(this.remainingDropboxes[i].latitude,this.remainingDropboxes[i].longitude);
        this.latlngbounds.extend(latlng);
      }

      console.log(this.mapMoved)

      // If the map hasn't been manually moved, get the last item in the list before the click to manage focus
      this.setFocusIndex = this.mapMoved ? 0 : this.dropboxList.length;

      this.map.fitBounds(this.latlngbounds);
    },
    findMarker (id) {
      return this.markers.find((marker) => {
        return marker.id == id;
      });
    },
    findDropbox (id) {
      return this.dropboxes.find((dropbox) => {
        return dropbox.id == id;
      });
    },
    removeMarker (marker, newMarkers) {
      marker.setMap(null);
      this.markers = newMarkers ? newMarkers : [];
    },
    setActiveMarker (marker) {
      this.markers.forEach((marker) => {
        marker.setIcon(this.dropboxTypes[marker.type].icon);
        marker.setZIndex();
      });
      marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
      marker.setIcon(this.dropboxTypes[marker.type].iconActive);
    }
  }
});




// WEBPACK FOOTER //
// ./src/js/dropbox/dropbox.js